import React, { createContext, useState, useContext } from 'react';

// Create User Context
const UserContext = createContext();

// Custom hook to use User Context
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

// User Provider Component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    name: 'Guest',
    email: '',
    isAuthenticated: false,
  });

  const login = (name, email) => {
    console.log('👤 User Context: User logging in', { name, email });
    setUser({
      name,
      email,
      isAuthenticated: true,
    });
  };

  const logout = () => {
    console.log('👤 User Context: User logging out');
    setUser({
      name: 'Guest',
      email: '',
      isAuthenticated: false,
    });
  };

  const updateUser = (updates) => {
    console.log('👤 User Context: Updating user', updates);
    setUser((prevUser) => ({
      ...prevUser,
      ...updates,
    }));
  };

  const value = {
    user,
    login,
    logout,
    updateUser,
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
